import script from "./ExceptionalJourney.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExceptionalJourney.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__